import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup
} from "@material-ui/core";
import { connect } from "react-redux";
import { addFieldData, setReturnedValue } from "../../actions";
import PriorityCode from "../PriorityCode";
import UploadFileQuestion from "./UploadFileQuestion";

class Ouinon extends Component {
  state = {
    value: "",
    isShowDialogUploadFile: false
  };

  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
  }

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
  }

  getData = () => {
    const dataKey = this.props.step.data.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      return this.props.dataSource[dataKey];
    }
    return null;
  };

  getRenderRadio = data => {
    if (data) {
      return data.map(item => {
        return (
          <FormControlLabel
            key={item.key}
            value={`${item.value}|${item.openUpload}`}
            datavalue={item.dataValue}
            control={<Radio color="primary" />}
            label={<div dangerouslySetInnerHTML={{ __html: item.label }} />}
            labelPlacement="start"
            className="raw-form line-radio"
          />
        );
      });
    }
    return [];
  };

  handleChange = event => {
    const keyValueReturned = this.props.step.returned.key;
    const valueArray = event.target.value.split("|");
    const value = event.currentTarget.attributes.datavalue
      ? event.currentTarget.attributes.datavalue.value
      : valueArray[0];
    if (keyValueReturned && value !== "") {
      this.props.setReturnedValue({
        idquestion: this.props.questionId,
        response: valueArray[0]
      });
      if (valueArray[1] === "N") {
        this.props.isValid(true);
        //this.setState({isShowDialogUploadFile: true});
      } else {
        this.setState({ isShowDialogUploadFile: true });
      }
    } else {
      this.props.isValid(false);
    }
    this.setState({ value: valueArray[0] });
  };

  render() {
    const { step } = this.props;
    const stepData = step.data;
    let data = this.getData();
    if (data && stepData.formatSource) {
      data = stepData.formatSource(data);
    }
    return (
      <>
        <FormControl component="fieldset">
          <FormLabel component="legend">
            <div dangerouslySetInnerHTML={{ __html: step.label }} />
          </FormLabel>
          {data && (
            <RadioGroup
              aria-label={step.label}
              name={"question"}
              onChange={this.handleChange}
            >
              {this.getRenderRadio(data)}
            </RadioGroup>
          )}
        </FormControl>
        {step.showLinkPriorityCode &&
          this.props.isShowLinkPriorityCode &&
          this.props.isFromAdmin !== "admin" && <PriorityCode />}
        {this.state.isShowDialogUploadFile && <UploadFileQuestion />}
      </>
    );
  }
}

Ouinon.propTypes = {
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  isFromAdmin: PropTypes.string,
  isShowLinkPriorityCode: PropTypes.any,
  isValid: PropTypes.func,
  questionId: PropTypes.any,
  resetData: PropTypes.func,
  setReturnedValue: PropTypes.func,
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      formatSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    label: PropTypes.any,
    returned: PropTypes.shape({
      key: PropTypes.any
    }),
    showLinkPriorityCode: PropTypes.any
  })
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    questionId: state.returnedValue.idquestion,
    isShowLinkPriorityCode: state.configuration.baffcodeprioritaire,
    isFromAdmin: state.returnedValue.from
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    resetData: key => dispatch(addFieldData(key, null))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Ouinon);
